import { TExtraWorkDayType, THalfDayType, VacationTypeDto } from "rpc/VacationRpc";

export class CalendarModel {

    public vacationDetailsDialogModel: VacationDetailsDialogModel = null;

    public constructor(
        public readonly isInit: boolean,
        public readonly searchTerm: string,
        public readonly monthSelectorModel: MonthSelectorModel,
        public readonly vacationCalendarModel: VacationCalendarModel,
    ) {}

}

export class MonthSelectorModel {

    public constructor(
        public readonly currentYear,
        public readonly selectedYear,
        public readonly selectedMont
    ) {}

}

export class VacationCalendarModel {

    public readonly teams: TeamModel[] = [];

    public constructor(
        public readonly daysCount: number,
        public readonly holidays: TExtraWorkDayType[],
        public readonly workdays: boolean[],
        public readonly dayIndex: number[],
    ) {}
}

export class TeamModel {

    public readonly users: UserVacationModel[] = [];
    public collapsed: boolean = false;

    public constructor(
        public readonly id: number,
        public readonly name: string
    ) {}

}

export class UserVacationModel {

    public readonly days: VacationDayModel;

    public constructor(
        monthLength: number,
        public readonly userId: number,
        public readonly userName: string,
        public readonly position: string,
    ) {
        this.days = new VacationDayModel(monthLength);
    }

}

export class VacationDayModel {

    public readonly ids: number[] = new Array(31);
    public readonly halfDays: THalfDayType[] = [];
    public readonly types: VacationTypeDto[] = [];
    public readonly descriptions: string[] = [];

    public constructor(monthLength: number) {
        this.ids = new Array(monthLength);
        this.halfDays = new Array(monthLength);
        this.types = new Array(monthLength);
        this.descriptions = new Array(monthLength);
    }

}

export class VacationDetailsDialogModel {

    public globalError: string;

    public constructor(
        public readonly id: number,
        public readonly type: string,
        public readonly halfDayType: THalfDayType,
        public readonly startDate: string,
        public readonly endDate: string,
        public readonly description: string,
        public readonly isDeleteVisible: boolean,
    ) {}

}